<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="col-md-12">
  <fieldset *ngIf="isWorldPay()">
    <legend class="row">
      <div class="col-md-6 m-auto">Account Details</div>
      <div class="col-md-6">
        <button
          class="btn btn-primary float-right"
          *ngIf="
            merchant.accountDetails.worldPayAccountDetails
              .backingWPMerchantExists &&
            hasFinanceRole() &&
            isWorldPay() &&
            isMerchantActive() &&
            !editable
          "
          (click)="setEditable(true)"
        >
          <span>
            <fa-icon [icon]="faEditPencil"></fa-icon>
          </span>
          Edit Account Details
        </button>
      </div>
    </legend>

    <div *ngIf="!editable">
      <div class="row" *ngIf="!merchant.accountDetails">
        <div class="col-md-12">
          <div class="col-md-6 offset-md-3 mt-3">
            <span class="row recordRow">
              Various Merchant Accounts and IDs have not been added yet.
            </span>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="merchant.accountDetails">
        <div class="col-md-12">
          <div class="mt-3">
            <div>
              <div class="table-block">
                <div class="recordRow">
                  <div class="recordLabel">Federal Tax ID</div>
                  <div id="federalTaxId" class="recordValue">
                    {{ merchant.accountDetails.federalTaxId }}
                  </div>
                </div>
                <div class="recordRow">
                  <div class="recordLabel">Account Usage</div>
                  <div id="depositAccountUsage" class="recordValue">
                    {{
                      merchant.accountDetails.separateFundingAccounts
                        ? "Funding Deposits"
                        : "Combined"
                    }}
                  </div>
                </div>

                <div
                  *ngIf="merchant.accountDetails.accountType"
                  class="recordRow"
                >
                  <div class="recordLabel">Account Type</div>
                  <div id="accountType" class="recordValue">
                    {{ merchant.accountDetails.accountType | accountTypeLabel }}
                  </div>
                </div>

                <div
                  class="recordRow"
                  *ngIf="
                    merchant.accountDetails.accountType &&
                    merchant.accountDetails.checkingDepositType &&
                    merchant.accountDetails.accountType === 'C'
                  "
                >
                  <div class="recordLabel">Checking Deposit Type</div>
                  <div id="amexSid" class="recordValue">
                    {{
                      merchant.accountDetails.checkingDepositType
                        | depositTypeLabel
                    }}
                  </div>
                </div>

                <div class="recordRow">
                  <div class="recordLabel">Routing Number (ABA)</div>
                  <div id="routingNumber" class="recordValue">
                    {{ merchant.accountDetails.routingNumber }}
                  </div>
                </div>

                <div class="recordRow">
                  <div class="recordLabel">Account Number (DDA)</div>
                  <div id="accountNumber" class="recordValue">
                    {{ merchant.accountDetails.accountNumber }}
                  </div>
                </div>
              </div>

              <div class="dividerRow"></div>
              <div
                *ngIf="
                  merchant.accountDetails.separateFundingAccounts &&
                  merchant.accountDetails.feeAccountDetails
                "
              >
                <div class="table-block">
                  <div class="recordRow">
                    <div class="recordLabel">Account Usage</div>
                    <div class="recordValue">Fee WithDrawls</div>
                  </div>
                  <div
                    *ngIf="
                      merchant.accountDetails.feeAccountDetails.accountType
                    "
                    class="recordRow"
                  >
                    <div class="recordLabel">Account Type</div>
                    <div class="recordValue">
                      {{
                        merchant.accountDetails.feeAccountDetails.accountType
                          | accountTypeLabel
                      }}
                    </div>
                  </div>
                  <div class="recordRow">
                    <div class="recordLabel">Routing Number (ABA)</div>
                    <div class="recordValue">
                      {{
                        merchant.accountDetails.feeAccountDetails.routingNumber
                      }}
                    </div>
                  </div>
                  <div class="recordRow">
                    <div class="recordLabel">Account Number (DDA)</div>
                    <div class="recordValue">
                      {{
                        merchant.accountDetails.feeAccountDetails.accountNumber
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="editable">
      <form
        name="generalInfoFormControl"
        class="form-horizontal"
        novalidate
        [formGroup]="accountDetailsForm"
        (submit)="updateElementMerchant()"
      >
        <app-account-details-edit
          [merchant]="merchant"
          [parentGroup]="accountDetailsForm"
        ></app-account-details-edit>
        <app-edit-buttons
          [buttonName]="buttonName"
          [actionInProgress]="actionInProgress"
          (editableEvent)="receiveEditEvent($event)"
        ></app-edit-buttons>
      </form>
    </div>
  </fieldset>
</div>
